import { createReducer } from '@reduxjs/toolkit'

import * as actions from '../../actions/Lists/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

export interface ListTable {
  attributes: { id: string; name: string }[]
  id: string
  title: string
  plural_title: string
  has_data: boolean
}

export type Preview = {
  data: { [offset: number]: any[] }
  count: number
  offset: number
  currentModel: string
  fetching: boolean
}

export interface ListsReducerType {
  tables: ListTable[]
  preview: Preview | null
  fetched: boolean
}

const INITIAL_STATE: ListsReducerType = {
  tables: [],
  preview: null,
  fetched: false
}

const listsReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.getTablesSuccess, (state, action) => {
      state.tables = action.payload.data
    })
    .addCase(actions.getData, (state, action) => {
      const { tableId } = action.payload

      if (state.preview && state.preview.currentModel === tableId) {
        state.preview.fetching = true
      } else {
        state.preview = {
          data: {},
          count: 0,
          offset: 0,
          currentModel: tableId,
          fetching: true
        }
      }
    })
    .addCase(actions.getDataSuccess, (state, action) => {
      const { count, offset, rows, tableId } = action.payload.data
      const { preview } = state

      // Pages of the same table and count are kept, anything else starts over.
      if (
        preview &&
        preview.currentModel === tableId &&
        preview.count === count
      ) {
        preview.data[offset] = rows
        preview.offset = offset
        preview.fetching = false
      } else {
        state.preview = {
          data: { [offset]: rows },
          count,
          offset,
          currentModel: tableId,
          fetching: false
        }
      }
    })
    .addCase(actions.getDataFailed, (state) => {
      if (state.preview) {
        state.preview.fetching = false
      } else {
        state.preview = {
          data: {},
          count: 0,
          offset: 0,
          currentModel: '',
          fetching: false
        }
      }
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
})

export default listsReducer
